module.exports = __webpack_public_path__ + "assets/img/angelinvestmentnetwork.65e85ad7.jpg";